import React, { FunctionComponent, useEffect } from 'react'
import { DesignLanguage, Flex, Heading, Icon, Modal, Text, useDesignLanguagePerClass, useIsDesignLanguage } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from '../../utils/convergence'
import styles from './style.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { CloseCheckout } from '../CloseCheckout'

interface EfaRobocallModalProps {
  isError?: boolean
}

export const EfaRobocallModal: FunctionComponent<EfaRobocallModalProps> = ({ isError = false }) => {
  const { headingSize } = useCheckoutSizes()
  const { t } = useTranslation()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const showModal = isError
  const testNameSpace = 'efa-robocall'
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const designLanguageClasses = useDesignLanguagePerClass(styles)

  useEffect(() => {
    logEvent(TrackingEvent.VIEWED_CL_EFA_ROBOCALL_MODAL)
  }, [])

  return (
    <Modal show={showModal} showCloseButton={false} testNameSpace={testNameSpace}>
      <div className={styles.container}>
        <Flex className={styles.informationPoint}>
          <Flex alignItems='center' justifyContent='center' className={designLanguageClasses.informationPointIcon}>
            <Icon.NewByronPhoneGeneral size={isArcadeDesignLanguage ? 'Medium' : 'Large'} />
          </Flex>
        </Flex>

        <Modal.Header>
          <Heading size={headingSize}>{t('consumerLending:efaRobocallModal.title')}</Heading>
        </Modal.Header>

        <Modal.Content>
          <div className={styles.modalText}>
            <Text size={'M'}>{t('consumerLending:efaRobocallModal.message1')}</Text>
            <div style={{ height: '30px' }}></div>
            <Text size={'M'}>{t('consumerLending:efaRobocallModal.message2')}</Text>
          </div>
          <CloseCheckout
            kind='Secondary'
            padding='Fluid'
            size='Large'
            testNameSpace={testNameSpace}
            onClick={() => logEvent(TrackingEvent.PRESSED_EFA_ROBOCALL_RETURN_TO_MERCHANT_BUTTON)}
          >
            {t('consumerLending:efaRobocallModal.returnToMerchantButton')}
          </CloseCheckout>
        </Modal.Content>
      </div>
    </Modal>
  )
}
